import { Patient } from '../store/types/prescription';
import { SEND_ATTACHMENTS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    status: 'success' | 'error';
    url: string;
    error?: string;
}

export interface Attachment {
    templateId?: string;
    post: {
        type: 'ATTACH';
        meta: {
            display: {
                title: string;
                description: string;
                link: string;
                file_type: string;
            };
        };
    };
    share: {
        type: 'PRIVATE';
        audience: [
            {
                id: string;
                profile: {
                    personal: {
                        name: string;
                        phone?: {
                            c?: string;
                            n?: string;
                        };
                        age?: {
                            dob?: string;
                        };
                        gender: string;
                        mobile?: string;
                        fn: string;
                    };
                };
            },
        ];
    };
}

export default ({
    attachments,
    blockTemplateMaking,
}: {
    attachments: Attachment;
    blockTemplateMaking?: boolean;
}): Promise<Response> =>
    fetchWithRefresh(SEND_ATTACHMENTS, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...attachments,
            blockTemplateMaking: blockTemplateMaking,
        }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('upload attachments failed');
        }
    });
